// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Pu23T","subHeader":"styles_subHeader__4E8tl","spacer":"styles_spacer__aNKLJ"};